import React from 'react'
import styled, { useTheme } from 'styled-components'
import { Body2, Link, Stack, screen } from '@tumelo/designsystem'
import { OuterContainerLayout } from '@/components/PageWrapper/OuterContainerLayout'

export type ColorTheme = 'light' | 'dark'

interface Props {
  colorTheme?: ColorTheme
  disablePrivacyPolicy?: boolean
  disableTermsAndConditions?: boolean
}

export const Footer: React.FC<Props> = ({
  colorTheme = 'light',
  disablePrivacyPolicy = false,
  disableTermsAndConditions = false,
}) => {
  const { colors } = useTheme()

  const textColor = colorTheme === 'dark' ? colors.white : colors.dark
  const linkColor = colorTheme === 'dark' ? 'white' : 'dark'
  const backgroundColor = colorTheme === 'dark' ? colors.background.dark : colors.background.medium

  return (
    <StyledFooter $backgroundColor={backgroundColor}>
      <StyledOuterContainerLayout $withMaxWidth={true}>
        <StyledStack flexDirection="row" justifyContent="space-between" alignItems="center">
          <StyledLinksStack flexDirection="row" justifyContent="space-between">
            {!disableTermsAndConditions && (
              <Link colour={linkColor} size="small" href="https://www.tumelo.com/terms-and-conditions">
                Terms & Conditions
              </Link>
            )}
            {!disablePrivacyPolicy && (
              <Link colour={linkColor} size="small" href="https://www.tumelo.com/privacy-policy">
                Privacy policy
              </Link>
            )}
          </StyledLinksStack>
          <StyledBody2 mb="0" color={textColor}>
            Copyright © 2026 Tumelo All rights reserved
          </StyledBody2>
        </StyledStack>
      </StyledOuterContainerLayout>
    </StyledFooter>
  )
}

const StyledLinksStack = styled(Stack)`
  width: 100%;
  @media ${screen.smallUp} {
    width: auto;
  }
`
const StyledOuterContainerLayout = styled(OuterContainerLayout)`
  padding-bottom: 0;
  padding-top: 0;
`

const StyledStack = styled(Stack)`
  padding: 1.6rem 0 3.2rem;

  @media ${screen.mediumUp} {
    padding: 2.8rem 0 3.2rem;
  }
  @media ${screen.largeUp} {
    padding: 4.8rem 0 7.2rem;
  }
`

const StyledBody2 = styled(Body2)`
  display: none;

  @media ${screen.smallUp} {
    display: block;
  }
`

const StyledFooter = styled.footer<{ $backgroundColor: string }>`
  background-color: ${({ $backgroundColor }) => $backgroundColor};
  border-top: 1px solid ${({ theme }) => theme.colors.grey.light};
  width: 100%;
`
